import { IntlShape } from 'react-intl';

export const getJobHoursDisplayText = (
  jobHours: string,
  intl: IntlShape,
): string => {
  switch (jobHours) {
    case 'full_time':
      return intl.formatMessage({
        defaultMessage: 'Full Time',
        description: 'Full time job hours type',
      });
    case 'part_time':
      return intl.formatMessage({
        defaultMessage: 'Part Time',
        description: 'Part time job hours type',
      });
    default:
      return jobHours;
  }
};

export const getJobTypeDisplayText = (
  jobType: string,
  intl: IntlShape,
): string => {
  switch (jobType) {
    case 'permanent':
      return intl.formatMessage({
        defaultMessage: 'Permanent',
        description: 'Permanent job type',
      });
    case 'temporary':
      return intl.formatMessage({
        defaultMessage: 'Temporary',
        description: 'Temporary job type',
      });
    case 'contract_freelancer':
      return intl.formatMessage({
        defaultMessage: 'Contract/Freelancer',
        description: 'Contract/Freelancer job type',
      });
    case 'casual':
      return intl.formatMessage({
        defaultMessage: 'Casual',
        description: 'Casual job type',
      });
    case 'finance_plus_accounting':
      return intl.formatMessage({
        defaultMessage: 'Finance & Accounting',
        description: 'Finance & Accounting job type',
      });
    case 'operations_leadership':
      return intl.formatMessage({
        defaultMessage: 'Operations & Leadership',
        description: 'Operations & Leadership job type',
      });
    case 'all_other_administrative_plus_professional':
      return intl.formatMessage({
        defaultMessage: 'Administrative & Professional',
        description: 'Administrative & Professional job type',
      });
    case 'information_technology':
      return intl.formatMessage({
        defaultMessage: 'Information Technology',
        description: 'Information Technology job type',
      });
    case 'customer_service_plus_operations':
      return intl.formatMessage({
        defaultMessage: 'Customer Service & Operations',
        description: 'Customer Service & Operations job type',
      });
    case 'local':
      return intl.formatMessage({
        defaultMessage: 'Local',
        description: 'Local job type',
      });
    case 'regional':
      return intl.formatMessage({
        defaultMessage: 'Regional',
        description: 'Regional job type',
      });
    case 'trainee':
      return intl.formatMessage({
        defaultMessage: 'Trainee',
        description: 'Trainee job type',
      });
    case 'shuttle':
      return intl.formatMessage({
        defaultMessage: 'Shuttle',
        description: 'Shuttle job type',
      });
    default:
      return jobType;
  }
};

export const getFilterOptionDisplayText = (
  key: string,
  type: 'jobType' | 'jobHours',
  intl: IntlShape,
): string => {
  if (type === 'jobType') {
    return getJobTypeDisplayText(key, intl);
  }
  if (type === 'jobHours') {
    return getJobHoursDisplayText(key, intl);
  }
  return key;
};

export const getPeriodDisplayText = (
  period: string | undefined,
  intl: IntlShape,
): string => {
  if (!period) return '';

  const periodLower = period.toLowerCase();
  switch (periodLower) {
    case 'hour':
      return intl.formatMessage({
        defaultMessage: '/hour',
        description: 'Pay rate period - per hour',
      });
    case 'day':
      return intl.formatMessage({
        defaultMessage: '/day',
        description: 'Pay rate period - per day',
      });
    case 'month':
      return intl.formatMessage({
        defaultMessage: '/month',
        description: 'Pay rate period - per month',
      });
    case 'year':
      return intl.formatMessage({
        defaultMessage: '/year',
        description: 'Pay rate period - per year',
      });
    default:
      return `/${period}`;
  }
};
